// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth"; 

const firebaseConfig = {
  apiKey: "AIzaSyAJk40yyAYYdlnOGd2q9lizKkhGfVcssBk",
  authDomain: "shade-fc1ff.firebaseapp.com",
  databaseURL: "https://shade-fc1ff-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "shade-fc1ff",
  storageBucket: "shade-fc1ff.firebasestorage.app",
  messagingSenderId: "858067163321",
  appId: "1:858067163321:web:dca45769e17f5bfd49e368",
  measurementId: "G-BFJTNYKQM3"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app); 
export { app, db, storage, auth }; 
